class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    // GF A-24 (01/10/2026): rimossi il fetch di /cart.js a ogni apertura e il timer della barra soglia legacy (E-21).
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  enableShippingBar(data){
    // GF A-24: barra legacy dismessa (E-21), il contenitore #shipping_bar non esiste piu' nel drawer.
    var shippingBar = document.getElementById('shipping_bar');
    if (!shippingBar) return;

    // GF 03/09/2026 - Lotto A. La barra soglia non deve mai promettere un porto
    // franco che il checkout non concede. Quattro uscite silenziose, in quest'ordine:
    //   1. cliente B2B loggato: le rate B2B (Split Shipment - B2B XX) non hanno soglia;
    //   2. carrello vuoto;
    //   3. Paese non ancora risolto dal geo-fetch: evitava il crash su [data-country=""];
    //   4. Paese senza soglia definita (CY, MT, GR, UK, CH, US): nessuna promessa possibile.
    // In tutti i casi la barra resta vuota e nascosta: l'assenza e' il fallimento corretto.
    var isB2B = document.body.dataset.gfB2b === '1';
    var countryEl = document.querySelector(".customer_country");
    var currentCountry = countryEl ? countryEl.value : "";
    var thresholdEl = currentCountry ? document.querySelector(`[data-country="${currentCountry}"]`) : null;
    var hasItems = data && data.items && data.items.length > 0;

    if (isB2B || !hasItems || !currentCountry || !thresholdEl) {
      shippingBar.innerHTML = "";
      shippingBar.style.display = "none";
      return;
    }

    var addEl = document.querySelector(".add_msg");
    var spendEl = document.querySelector(".spend_msg");
    var congratsEl = document.querySelector(".congrats_msg");
    if (!addEl || !spendEl || !congratsEl) {
      shippingBar.innerHTML = "";
      shippingBar.style.display = "none";
      return;
    }

    var cartTotal = data.total_price/100;
    var addMsg = addEl.value;
    var spendMsg = spendEl.value;
    var congratsMsg = congratsEl.value;
    var threshold_price = parseInt(thresholdEl.value)/100;

    if (!isFinite(threshold_price) || threshold_price <= 0) {
      shippingBar.innerHTML = "";
      shippingBar.style.display = "none";
      return;
    }

    var shippingBarHtml = `<div class="amount1">
      <span class="amount-start">€0</span>
      <progress id="bar" max="${threshold_price}" value="${cartTotal}"></progress> 
      <span class="amount-end">€${threshold_price}</span>
    </div>
    <p class="messg">${addMsg} <span class="number">€${(threshold_price - cartTotal).toFixed(2)}</span> ${spendMsg}</p>`;

    var successBarHtml = `<p class="outmessg cart_drawer" style="font-size: 14px;">${congratsMsg}</p>`;

    shippingBar.style.display = "block";

    if(threshold_price >= cartTotal){
      shippingBar.innerHTML = shippingBarHtml;
    }
    else{
      shippingBar.innerHTML = successBarHtml;
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
   
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
   
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);